module.exports = __webpack_public_path__ + "img/chevron-up-down.0615c182.svg";